module.exports = __webpack_public_path__ + "img/introduction.c69e7618.svg";